"use strict";
/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * @module people
 * @description
 */

module.exports = function (config, get, post, upload) {
	return {
		data: getall_data,
		public: publicData,
		update: update,
		picture: picture,
		available: available,
		statuses: statuses,
		search: search,
		block: manage_blocking(config, get, post),
		app: {
			lock: update_app_lock,
			unlock: update_app_unlock
		},
		version: updateVersion
	};

	/**
	 * Gets verbose data for a user
	 * @param  {String}  token User's session token
	 * @return {Promise}       Resolves to most interesting data about a user, including config
	 */
	function getall_data() {
		return get("/v2/people/data", {});
	}

	/**
	 * Gets the public data of a list of people
	 * @param  {Array}   ids The ids of people whose info to fetch
	 * @param  {String}  timestamp the most recent timestamp of all people whose info we want to fetch
	 * @return {Promise}     Resolves to array of objects with fname,lname,_id,image,type
	 */
	function publicData(ids, timestamp) {
		return get("/v2/people/public", {
			who: ids,
			updated_at: timestamp
		});
	}

	/**
	 * Updates the user's information
	 * @param  {Object} data Data to update user with, optionally contains token
	 * @return {Promise}     Resolves if update was successful
	 */
	function update(data) {
		return post("/v2/people/update", data);
	}

	/**
	 * Uploads a new profile picture
	 * @param  {File}    file    Reference to picture's file
	 * @param  {Object}  options Optional `crop` and `rotate` properties for cropping
	 * @return {Promise}         Resolves to something or other
	 */
	function picture(file, options) {
		return upload("/v2/people/picture", options, "picture", file);
	}

	/**
	 * This function causes the server to execute the 'appear offline' functionality.
	 * It is called from 'thehub-mobile' with one argument, the
	 * argument is 'state'.
	 * @method availability
	 * @param  {String}     state Desired 'state' of availability true/false.
	 * @return {Promise}         Post
	 */
	function available(state) {
		return post("/v2/people/available", {
			state: state
		});
	}

	/**
	 * Searches for users
	 * @param  {String} query 	Query to search for users with
	 * @param {Object}	filter	At the moment, object with attribute 'type' consisting of two arrays of strings of type names: include/exclude
	 * @return {Promise}      	Resolves to array of users that match the query
	 */
	function search(query, filter) {

		if (filter && filter.type) {
			var includeType = filter.type.include;
			var excludeType = filter.type.exclude;
		}

		return get("/v2/people/search", {
			q: query,
			includeType: includeType,
			excludeType: excludeType
		});
	}

	/**
	 * Fetches the availability statuses of arbitrary users
	 * @param  {Array}   who Array of ids to fetch statuses for
	 * @return {Promise}     Resolves to a map of <id, status>
	 */
	function statuses(who, filter) {
		if (!filter) filter = "none";
		return get("/v2/people/statuses", {
			who: who,
			filter: filter
		});
	}

	function update_app_lock(){
		return post("/v2/people/app/lock");
	}

	function update_app_unlock(){
		return post("/v2/people/app/unlock");
	}

	function updateVersion(versionInfo){
		return post("/v2/people/version/update", {
			versionInfo
		})
	}
};

function manage_blocking(config, get, post) {

	function block(blockee) {
		return post("/v2/people/block", {
			who: blockee
		});
	}

	function unblock(blockee) {
		return post("/v2/people/block/unblock", {
			who: blockee
		});
	}

	function list(blocker) {
		return get("/v2/people/block/list", {
			who: blocker
		});
	}

	return {
		block: block,
		unblock: unblock,
		list: list
	};
}
